import Head from "next/head";

import PartnerDetails from "@/components/partners/partner-details";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";
import { partnerSlugs } from "@/utils/partner-paths";

export default function Partner() {
  return (
    <>
      <Head>
        <title>{seoData.PARTNER.title}</title>
        <SeoMetaData data={seoData.PARTNER} />
      </Head>

      <PartnerDetails />
    </>
  );
}

// Previously this route had NO data function (it relied on automatic static
// optimization + client useRouter()), but output:"export" hard-errors on a
// dynamic route without getStaticPaths. Enumerate every partner slug from local
// data so each partner detail page is prerendered (unknown slugs 404 until rebuild).
export async function getStaticPaths() {
  const paths = partnerSlugs.map((partner) => ({ params: { partner } }));
  return { paths, fallback: false };
}

export async function getStaticProps({ params }: any) {
  return { props: { partner: params.partner } };
}
